export default __webpack_public_path__ + "static/media/button_placement__copy_selector.b91d7a5f.png";